module.exports = __webpack_public_path__ + "img/skip-backward-btn-fill.2447c4c2.svg";